import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("zrh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    // Only a genuine 401 (invalid/expired token) should log the admin out.
    // 403 can be returned by Cloudflare/WAF and must NOT clear the session,
    // otherwise the admin panel gets stuck in a login redirect loop.
    if (
      status === 401 &&
      typeof window !== "undefined" &&
      window.location.pathname.startsWith("/admin") &&
      !window.location.pathname.includes("/admin/login")
    ) {
      localStorage.removeItem("zrh_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

export default api;
export { API };

export const mediaUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

